import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/required-uuid-string.js';
export const matchLeafLinkHeldOrderCustomerArgsSchema = z.object({
    heldOrderId: requiredUuidString('Held order is required.', 'Invalid held order.'),
    customerId: requiredUuidString('Customer is required.', 'Invalid customer selection.'),
});
//# sourceMappingURL=match-leaflink-held-order-customer-args-schema.js.map